export default "__VITE_ASSET__DIEkdYdJ__"